import { CurrencyCode } from 'further-types/lp/vehicle';
import InvestorTable from './InvestorTable';
import TotalsTable from './TotalsTable';
import { Row } from 'components/Layout';
import { InvestorAllocationTotals } from '../../types';

type Props = {
  currency: CurrencyCode;
  investorAllocationsTotals: Array<InvestorAllocationTotals>;
};

const PerInvestorAllocationTable: React.FC<Props> = ({
  currency,
  investorAllocationsTotals,
}) => {
  return (
    <Row>
      <InvestorTable
        investorAllocationsTotals={investorAllocationsTotals}
        currency={currency}
      />
      <TotalsTable
        investorAllocationsTotals={investorAllocationsTotals}
        currency={currency}
      />
    </Row>
  );
};

export default PerInvestorAllocationTable;
